<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h5>Neraca Lajur</h5>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <label for="month" class="col-sm-3 col-form-label text-left">Date</label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="year"/>
                            </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary" @click="refreshList">Search</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <tr>
                                <th width="25%">Account</th>
                                <th colspan="2" class="text-center">Januari</th>
                                <th colspan="2" class="text-center">Februari</th>
                                <th colspan="2" class="text-center">Maret</th>
                                <th colspan="2" class="text-center">April</th>
                                <th colspan="2" class="text-center">Mei</th>
                                <th colspan="2" class="text-center">Juni</th>
                                <th colspan="2" class="text-center">July</th>
                                <th colspan="2" class="text-center">Agustus</th>
                                <th colspan="2" class="text-center">September</th>
                                <th colspan="2" class="text-center">Oktober</th>
                                <th colspan="2" class="text-center">November</th>
                                <th colspan="2" class="text-center">Desember</th>
                            </tr>

                            <tr>
                                <th>#</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                                <th>Debit</th><th>Credit</th>
                            </tr>
                            <tbody>
                                <tr v-for="a in account" :key="a.account_code">
                                    <td>{{ a.account_code}} {{ a.account_name }}</td>
                                    <td v-for="t in a.total" :key="t.id">
                                        <span v-if="t.method =='debit'">{{ t.debit | currency }}</span>
                                        <span v-else-if="t.method =='credit'">{{ t.credit | currency }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                      </div>
                    </div>
                </div>
            </div>
            <div class="card-footer"></div>
        </div>
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader } from '../../config'
export default {
  name: 'NeracaLajur',
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      account: [{
        account_code: null,
        account_name: null,
        total: [{
          month: null,
          debit: 0,
          credit: 0
        }]
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  mounted () {
    this.refreshList()
  },
  methods: {
    editJournal: function (id) {
      alert(id)
    },
    refreshList: function () {
      var url = financeUrl + '/neraca-lajur?year=' + this.year
      console.log(url)
      Axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.account = response.data.data
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  }
}
</script>
